import React from "react";
import "./Adv_card_section.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";



function Adv_card_section() {
    
  return (
    <>
      <section className="Adv_card_section">
        <div className="custom_container">
          {/* Swiper */}
          <Swiper
            slidesPerView={3.4}
            spaceBetween={40}
            loop={true}
            className="Adv_card_section_swiper"
            breakpoints={{
              0: {
                slidesPerView: 1.2,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 1.5,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1200: {
                slidesPerView: 3.4,
                spaceBetween: 40,
              },
            }}
          >
            <SwiperSlide>
              <div className="adv_img_holder">
                <img
                  src="/assets/Images/Home/Adv_card_section/img_1.png"
                  alt="banner1"
                  className="adv_img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="adv_img_holder">
                <img
                  src="/assets/Images/Home/Adv_card_section/img_2.png"
                  alt="banner2"
                  className="adv_img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="adv_img_holder">
                <img
                  src="/assets/Images/Home/Adv_card_section/img_3.png"
                  alt="banner3"
                  className="adv_img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="adv_img_holder">
                <img
                  src="/assets/Images/Home/Adv_card_section/img_4.png"
                  alt="banner3"
                  className="adv_img"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Adv_card_section;
